<template>
	<div id="wrapper">
		<SidebarView :all-loans="true" :loanVisible="true" :loan="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="mx-3">
					<div class="card card-shape home-box">
						<div class="card-header d-flex flex-row align-items-center justify-content-between">
							<h6 class="m-0 fw-bold text-green">All Loans</h6>
							<b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
								<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
						</div>
						<div class="card-body default_bg" style="border-bottom: 1px solid rgb(1, 134, 115)">
							<div class="home-box border border-success py-1 bg-white">
								<div class="my-1 row text-center my-2">
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-green rounded-circle" />
											Total Loan Disbursed<br />
											{{ institution.currency_code }}
											{{
												displayNumber(
													Number(
														summary.total_loans_disbursed
													).toFixed(2)
												)
											}}
											<!-- <span class="fw-bold">{{
                                                displayNumber(total_complete_deposits) }}</span> -->
										</p>
									</div>
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-danger rounded-circle" />
											Total Principal Balance <br />
											{{ institution.currency_code }}
											{{
												displayNumber(
													Number(
														summary.total_principal_balance
													).toFixed(2)
												)
											}}
											<!-- <span class="fw-bold">{{
                                                displayNumber(total_complete_withdrawals)
                                                }}</span> -->
										</p>
									</div>
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-grey rounded-circle" />
											Total Interest Expected <br />{{
												institution.currency_code
											}}
											{{
												displayNumber(
													Number(
														summary.total_interest_expected
													).toFixed(2)
												)
											}}
										</p>
									</div>
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-orange-text rounded-circle" />
											Total Interest Balance<br />{{
												institution.currency_code
											}}
											{{
												displayNumber(
													Number(
														summary.total_interest_balance
													).toFixed(2)
												)
											}}
										</p>
									</div>
									<div class="col">
										<p class="mb-0 small">
											<font-awesome-icon :icon="['fas', 'circle']"
												class="akkurate-blue-text rounded-circle" />
											Loan Balance : <br />{{
												institution.currency_code
											}}
											{{
												displayNumber(
													Number(
														summary.total_loan_balance
													).toFixed(2)
												)
											}}
										</p>
									</div>
								</div>
								<hr class="m-0" />
								<div class="card-body">
									<form @submit.prevent="filterTable">
										<div class="row">
											<div class="col-12 col-md-4">
												<label class="akkurate-dark small d-none d-lg-block"
													for="search">Search</label>
												<b-form-group id="search" label-for="search" class="akkurate-dark">
													<b-form-input id="search" class="mt-2 field-container fields"
														type="text" v-model="form.filter"
														placeholder="Customer name, phone number, customer code, email">
													</b-form-input>
												</b-form-group>
											</div>
											<div class="col">
												<label class="akkurate-dark small d-none d-lg-block"
													for="loan_number">Loan number</label>
												<b-form-group id="loan_number" label-for="loan_number"
													class="akkurate-dark">
													<b-form-input id="loan_number" class="mt-2 field-container fields"
														type="text" v-model="form.loan_number
															" placeholder="Enter Loan number">
													</b-form-input>
												</b-form-group>
											</div>

											<div class="col mb-2 mb-md-0">
												<label class="akkurate-dark small d-none d-lg-block"
													for="type">Status</label>
												<multiselect class="mt-2 field-container" v-model="form.status"
													:options="form.status_option
														">
												</multiselect>
											</div>
											<div class="col mb-2 mb-md-0">
												<label class="akkurate-dark small d-none d-lg-block"
													for="type">Gender</label>
												<multiselect class="mt-2 field-container" v-model="form.gender"
													:options="form.gender_option
														">
												</multiselect>
											</div>
											<div
												class="d-grid gap-2 col-md-2 d-flex align-content-center justify-content-center mt-auto">
												<b-button type="submit"
													class="akkurate-green-btn akkurate-auth-size w-100 d-flex align-items-center justify-content-center">
													<i class="fas fa-search"></i><span
														class="d-none d-lg-block ms-2">Search</span>
												</b-button>
												<b-button size="sm" v-b-modal.loan-filter title="show more filters"
													class="ms-2">
													<i class="fas fa-bars akkurate-small"></i>
												</b-button>
												<!-- <router-link :to="{ name: 'loan.merge', query: { loan_number: form.loan_number } }" class="btn akkurate-orange-btn ms-2">
													<i class="fas fa-object-group me-2"></i>
													Merge Loans
												</router-link> -->
											</div>
										</div>
									</form>
								</div>
								<b-modal size="lg" id="loan-filter" content-class="rounded-1" @ok="handleOk">
									<template #modal-title>
										<h6 class="fw-bold mb-0 akkurate-green">
											Filter
										</h6>
									</template>
									<loan-filter :form="form" :branch_option="branch_option"
										:schemes_option="schemes_option" @branch_arr="branch_array"
										@schemes_arr="schemes_array" :loan_stages_options="loan_stages_options
											"></loan-filter>
									<template #modal-footer="{ ok }">
										<div class="w-100">
											<!-- Emulate built in modal footer ok and cancel button actions -->
											<b-button @click="
												$bvModal.hide('loan-filter')
												" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span
													class="small"><font-awesome-icon class="me-2" :icon="[
														'fas',
														'close',
													]" />Close
												</span></b-button>
											<b-button @click="ok()" type="submit" :disabled="isSaving"
												class="akkurate-green-btn btn-size float-right border-0"><span
													class="small"><font-awesome-icon class="me-2" :icon="[
														'fas',
														'search',
													]" />Search</span></b-button>
										</div>
									</template>
								</b-modal>
							</div>
						</div>
						<div class="card-body px-0 pt-0">
							<div class="table_text_size">
								<b-table striped bordered responsive id="loan-table" :busy.sync="isBusy" :items="rows"
									:fields="fields" :tbody-tr-class="rowClass" show-empty>
									<template #table-busy>
										<div class="text-center text-danger my-2">
											<b-spinner class="align-middle"></b-spinner>
											<strong>Loading...</strong>
										</div>
									</template>
									<template #empty="scope">
										<h4 class="text-center small mt-3">
											{{ scope.emptyText }}
										</h4>
									</template>
									<template #cell(loan_number)="data">
										<div v-if="data.item?.loan?.loan_top_ups?.length > 0"
											v-b-tooltip.hover="{ variant: 'info' }" title="Pending Loan Topup">
											{{ data.item?.loan?.loan_number }}
										</div>
										<div v-else-if="data.item?.loan?.refinanced_loan_id == 1"
											v-b-tooltip.hover="{ variant: 'info' }" title="Pending Loan Refinance">
											{{ data.item?.loan?.loan_number }}
										</div>
										<div v-else>
											{{ data.item?.loan?.loan_number }}
										</div>
									</template>
									<template #cell(loan_status)="data">
										<div v-if="data.item?.loan?.loan_top_ups?.length > 0"
											v-b-tooltip.hover="{ variant: 'info' }" title="Pending Loan Topup">
											<span :class="statusBadge(data.item.loan?.status)">{{
												data.item.loan?.status }}</span>
										</div>
										<div v-else-if="data.item?.loan?.refinanced_loan_id == 1"
											v-b-tooltip.hover="{ variant: 'info' }" title="Pending Loan Refinance">
											<span :class="statusBadge(data.item.loan?.status)">{{
												data.item.loan?.status }}</span>
										</div>
										<div v-else>
											<span :class="statusBadge(data.item.loan?.status)">{{
												data.item.loan?.status }}</span>
										</div>
									</template>
									<!-- A custom formatted column -->
									<template #cell(customer)="data">
										<div>
											{{ data.item.customer.first_name }} {{ data.item.customer.last_name }}
										</div>
									</template>
									<template #cell(principal_amount)="data">
										<div>
											{{ displayNumber(data.item?.loan?.principal_amount) }}
										</div>
									</template>
									<template #cell(principal_balance)="data">
										<div>
											{{ displayNumber(data.item.loan?.principal_balance) }}
										</div>
									</template>
									<template #cell(expected_interest)="data">
										<div>
											{{ displayNumber(data.item.loan?.expected_interest) }}
										</div>
									</template>
									<template #cell(interest_balance)="data">
										<div>
											{{ displayNumber(data.item.loan?.interest_balance) }}
										</div>
									</template>
									<template #cell(loan_balance)="data">
										<div>
											{{ displayNumber(data.item.loan?.loan_balance) }}
										</div>
									</template>
									<template #cell(references)="data">
										<div v-if="data.item?.loan?.loan_top_ups?.length > 0"
											v-b-tooltip.hover="{ variant: 'info' }" title="Pending Loan Topup">
											<a title="Click to view ledger entries"
												class="text-decoration-none akkurate-green"
												:href="`/chart-of-accounts/transactions?reference=LOA${data.item.loan?.id}`">LOA{{
													data.item.loan?.id }}</a>
										</div>
										<div v-else-if="data.item?.loan?.refinanced_loan_id == 1"
											v-b-tooltip.hover="{ variant: 'info' }" title="Pending Loan Refinance">
											<a title="Click to view ledger entries"
												class="text-decoration-none akkurate-green"
												:href="`/chart-of-accounts/transactions?reference=LOA${data.item.loan?.id}`">LOA{{
													data.item.loan?.id }}</a>
										</div>
										<div v-else>
											<a
												title="Click to view ledger entries"
												class="text-decoration-none akkurate-green"
												:href="`/chart-of-accounts/transactions?reference=LOA${data.item.loan?.id}`">LOA{{
													data.item.loan?.id }}</a>
										</div>
									</template>
									<template #cell(actions)="data">
										<span class="d-flex">
											<a title="View"
												class="btn btn-sm text-white akkurate-warning border-0 custom-pointer"
												@click="onViewLoan(data.item, 'view')">
												<span class="akkurate-small">
													<font-awesome-icon :icon="['fas', 'eye']" />
												</span>
											</a>
											<a title="Edit"
												class="btn btn-sm text-white akkurate-blue border-0 custom-pointer"
												@click="showLoanEditModal(data.item?.loan)">
												<span class="akkurate-small"><font-awesome-icon
														:icon="['fas', 'edit']" />
												</span>
											</a>

											<div class="dropdown no-arrow d-inline" v-if="
												data.item.loan?.status.toUpperCase() == 'RUNNING' ||
												data.item.loan?.status.toUpperCase() == 'EXPIRED'">
												<a title="More Action"
													class="btn btn-sm text-white akkurate-gray-btn custom-pointer border-0 dropdown-toggle"
													id="dropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true"
													aria-expanded="false">
													<span class="akkurate-small">
														<font-awesome-icon :icon="[
															'fas',
															'money-bill-transfer',
														]" />
													</span>
												</a>
												<div class="dropdown-menu shadow animated--fade-in"
													aria-labelledby="dropdownMenu">
													<div class="dropdown-header">
														More Actions
													</div>
													<button class="custom-dropdown-item icon-color"
														@click="onViewLoan(data.item, 'repay')">
														Loan Repayment
														<i class="icon-color fas fa-money-bill"></i>
													</button>
													<b-dropdown-divider
														class="custom-divider-margin"></b-dropdown-divider>
													<button class="custom-dropdown-item icon-color" @click="
														onViewLoan(
															data.item,
															'topup'
														)
														">
														Loan Topup
														<i class="icon-color fas fa-coins"></i>
													</button>
													<b-dropdown-divider
														class="custom-divider-margin"></b-dropdown-divider>

													<button class="custom-dropdown-item icon-color" @click="
														onViewLoan(
															data.item,
															'adjustment'
														)
														">
														Loan Adjustment
														<i class="icon-color fas fa-adjust"></i>
													</button>
													<b-dropdown-divider
														class="custom-divider-margin"></b-dropdown-divider>

													<button class="custom-dropdown-item icon-color" @click="
														onViewLoan(
															data.item,
															'status'
														)
														">
														Change Status
														<i class="icon-color fas fa-toggle-on"></i>
													</button>
													<b-dropdown-divider
														class="custom-divider-margin"></b-dropdown-divider>

													<button class="custom-dropdown-item icon-color" @click="
														onViewLoan(
															data.item,
															'refinance'
														)
														">
														Refinance
														<i class="icon-color fas fa-piggy-bank"></i>
													</button>
													<b-dropdown-divider
														class="custom-divider-margin"></b-dropdown-divider>

													<button class="custom-dropdown-item icon-color" @click="
														onViewLoan(
															data.item,
															'write_off'
														)
														">
														Write off
														<i class="icon-color fas fa-times-circle"></i>
													</button>
													<b-dropdown-divider
														class="custom-divider-margin"></b-dropdown-divider>

													<button class="custom-dropdown-item icon-color"
														@click="showMergeModal(data.item?.loan?.loan_number)">
														Merge Loan
														<i class="icon-color far fa-clone"></i>
													</button>
													<b-dropdown-divider
														class="custom-divider-margin"></b-dropdown-divider>
													<button class="custom-dropdown-item icon-color"
														@click="showSwapModal(data.item?.loan?.loan?.loan_number || data.item?.loan?.loan_number)">
														Swap Loan
														<i class="icon-color fas fa-exchange-alt"></i>
													</button>
													<!-- <b-dropdown-divider
														class="custom-divider-margin"></b-dropdown-divider>
													<button class="custom-dropdown-item icon-color"
														@click="gotoMerge(data.item?.loan?.loan_number)">
														Transfer Loan
														<i class="icon-color fas fa-share"></i>
													</button> -->
												</div>
											</div>

											<a v-if="
												data.item.loan?.status.toUpperCase() !==
												'RUNNING' &&
												data.item.loan?.status.toUpperCase() !==
												'CLOSED'
											" title="Delete" class="btn btn-sm text-white akkurate-danger-btn border-0 custom-pointer"
												@click="deleteLoan(data.item)">
												<span class="akkurate-small"><font-awesome-icon :icon="[
													'fas',
													'trash',
												]" /></span>
											</a>
										</span>
									</template>
								</b-table>
								<div class="d-flex justify-content-between pt-1 px-3 pb-3">
									<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
										:total-rows="totalRecords" :per-page="perPage"
										aria-controls="loan-table"></b-pagination>

									<div class="col text-end mt-1">
										<div>
											{{ currentPage }} - {{ perPage }} of
											{{ totalRecords }}
										</div>
										<b-form-group label="Per Page" label-size="sm" class="mb-0">
											<b-form-select @change="selectPerPage" id="per-page-select"
												v-model="perPage" :options="per_page_options" size="sm"></b-form-select>
										</b-form-group>
									</div>
								</div>
								<!-- Modal: Loan View (Unique for Each Row) -->
								<b-modal :id="'loan-modal-' + currentLoanId" size="xxl"
									style="background-color: #83cae830;" @shown="showView" @hidden="onLoanModalHidden">
									<template #modal-title>
										<h6 class="m-0 fw-bold text-green">
											Loan View
										</h6>
									</template>

									<!-- Loan View Component -->
									<loan-view :data="currentLoanData" :user="user" :institution="institution"
										:coa_subheads="coa_subheads" :term_active_menu="term_active_menu"
										:repayment_active_menu="repayment_active_menu"
										:statement_active_menu="statement_active_menu"
										:entries_active_menu="entries_active_menu"
										:adjustment_active_menu="adjustment_active_menu"
										:topup_active_menu="topup_active_menu"
										:refinance_active_menu="refinance_active_menu"
										:writeoff_active_menu="writeoff_active_menu" :user_pemissions="user_pemissions"
										:user_role="user_role" :status_active_menu="status_active_menu"
										:current_user_id="current_user_id" @loanApprovedAction="loanApprovedAction"
										@loanAdjustmenetSaved="loanAdjustmenetSaved"
										@reloadLoans="reloadLoans"></loan-view>
									<template #modal-footer>
										<div class="w-100">
											<b-button @click="$bvModal.hide('loan-modal-' + currentLoanId)"
												type="submit" class="akkurate-gray-btn btn-size float-right">
												<font-awesome-icon class="me-2" :icon="['fas', 'close']" />Close
											</b-button>
										</div>
									</template>
								</b-modal>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>

		<b-modal size="lg" id="bv-modal-loan-edit" hide-footer>
			<template #modal-title>
				<h6 class="m-0 fw-bold text-green text-sm">Loan Edit</h6>
			</template>
			<loan-edit :loan_edit="loan_edit" @savedEdit="savedEdit"></loan-edit>
		</b-modal>
		<b-modal size="lg" id="bv-modal-merge-loan" hide-footer>
			<template #modal-title>
				<h6 class="m-0 fw-bold text-green text-sm">
					Merge Loan
				</h6>
			</template>
			<merge :loan_number="loan_number" @loanMerged="loanMerged"></merge>
		</b-modal>
		<b-modal size="lg" id="bv-modal-swap-loan" hide-footer>
			<template #modal-title>
				<h6 class="m-0 fw-bold text-green text-sm">
					Swap Loan
				</h6>
			</template>
			<swap :loan_number="loan_number" @loanSwapped="loanSwapped"></swap>
		</b-modal>
	</div>
</template>
<script>
import SidebarView from '@/views/main/components/Sidebar.vue';
import TopbarView from '@/views/main/components/Topbar.vue';
import Footer from '@/views/main/components/Footer.vue';
import LoanFilter from '../forms/LoanFilter.vue';
import LoanEdit from '../edit/LoanEdit.vue';
import ApiService from "@/core/services/api.service";
import { decryptData } from '@/crypto';
import LoanView from '../view/LoanView.vue';
import { hasPermission } from '@/helper';
import Multiselect from 'vue-multiselect';
import * as XLSX from 'xlsx';
import FileSaver from "file-saver";
import Merge from '../view/loan-actions/Merge.vue';
import Swap from '../view/loan-actions/Swap.vue';
import ChatBot from '@/views/components/AI/ChatBot.vue';
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		LoanFilter,
		LoanView,
		LoanEdit,
		Multiselect,
		Merge,
		Swap,
		ChatBot,
	},
	data() {
		return {
			totalRecords: 0,
			searchFilter: "",
			isLoading: true,
			isSaving: false,
			institution: {},
			statement: "statement",
			entries: "entries",
			currentLoanId: null, // Track the currently viewed loan ID
			currentLoanData: null, // Track the current loan's data to display in the modal
			term_active_menu: true, // Default active tab is "Loan Term"
			repayment_active_menu: false, // Default inactive tab is "Repayments"
			statement_active_menu: false,
			entries_active_menu: false,
			adjustment_active_menu: false,
			topup_active_menu: false,
			refinance_active_menu: false,
			writeoff_active_menu: false,
			status_active_menu: false,
			user_pemissions: "",
			user_role: "",
			current_user_id: "",
			user_role: false,
			loan_edit: {},
			isBusy: true,
			currentPage: 1,
			perPage: "10",
			per_page_options: ['10', '20', '50', '100', '200', '200', '500', '1000'],
			per_page_selected: "10",
			summary: {
				total_loans_disbursed: 0,
				total_principal_balance: 0,
				total_interest_expected: 0,
				total_interest_balance: 0,
				total_loan_balance: 0,
			},
			loan_number: "",

			form: {
				branch: "",
				filter: "",
				schemes: "",
				search: "",
				loan_number: "",
				branch_ids: "",
				schemes_ids: "",
				status_option: [
					"PENDING",
					"UNDER_REVIEW",
					"RUNNING",
					"DISBURSED",
					"CLOSED",
					"REJECTED",
					"WRITTEN_OFF",
					"EXPIRED"
				],
				status: "",
				loan_stages: "",
				gender: "",
				gender_option: ["Male", "Female", "Group"],
				term: "",
			},

			user: [],
			branch_option: [],
			schemes_option: [],
			user_branch: [],
			coa_subheads: {},
			loan_stages_options: [],
			fields: [

				{
					label: 'Loan #',
					key: 'loan_number',
				},
				{
					label: 'Loan_Name',
					key: 'loan.loan_product.name',
				},
				{
					label: 'References',
					key: 'references',
				},
				{
					label: 'Borrower_Name',
					key: 'customer',
				},
				{
					label: 'Principal',
					key: 'principal_amount',
				},
				{
					label: 'Principal_Bal',
					key: 'principal_balance',
				},
				{
					label: 'Expected_Interest',
					key: 'expected_interest',
				},
				{
					label: 'Interest_Bal',
					key: 'interest_balance',
				},
				{
					label: 'Total_Bal',
					key: 'loan_balance',
				},
				{
					label: 'Start_Date',
					key: 'loan.interest_start_date',
				},
				{
					label: 'Status',
					key: 'loan_status',
				},
				{
					label: 'Actions',
					key: 'actions',
				},
			],
			rows: [],
			_openingLoanRoute: null,
		}
	},
	watch: {
		$route(to, from) {
			if (
				from &&
				from.name === "loan.detail" &&
				to.name !== "loan.detail" &&
				this.currentLoanId != null
			) {
				this.$bvModal.hide("loan-modal-" + this.currentLoanId);
			}
			this.tryOpenLoanFromRoute(to);
		},
	},
	mounted() {
		this.getLoanDropdown();
		this.getInsistution();
		this.loadItems();
		this.$nextTick(() => this.tryOpenLoanFromRoute(this.$route));
	},
	methods: {
		normalizeLoanRowForView(payload) {
			if (!payload || typeof payload !== "object") {
				return null;
			}
			if (payload.loan && typeof payload.loan === "object") {
				return {
					id: payload.id != null ? payload.id : payload.loan.id,
					loan: payload.loan,
					customer:
						payload.customer != null
							? payload.customer
							: payload.loan?.account?.customer,
				};
			}
			const loan = payload;
			if (loan.id == null && loan.loan_number == null) {
				return null;
			}
			return {
				id: loan.id,
				loan,
				customer: loan.account?.customer,
			};
		},
		async tryOpenLoanFromRoute(route) {
			const r = route || this.$route;
			if (r.name !== "loan.detail" || !r.params.loan_number) {
				return;
			}
			const code = String(r.params.loan_number).trim();
			if (!code) {
				return;
			}
			if (this._openingLoanRoute === code) {
				return;
			}
			this._openingLoanRoute = code;
			this.$Progress.start();
			try {
				const response = await ApiService.get(
					`/loans/${encodeURIComponent(code)}`,
				);
				const row = this.normalizeLoanRowForView(response.data.data);
				if (!row || !row.loan) {
					throw new Error("Invalid loan response");
				}
				this.onViewLoan(row, "view");
			} catch (error) {
				const msg =
					(error.response && error.response.data && error.response.data.message) ||
					(error && error.message) ||
					"Could not load loan.";
				swal.fire({
					icon: "error",
					text: msg,
					allowOutsideClick: true,
					showCancelButton: false,
					confirmButtonText: "OK",
					buttonsStyling: false,
					customClass: {
						confirmButton:
							"btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
					},
				});
				if (this.$route.name === "loan.detail") {
					this.$router.replace({ name: "loan.index" });
				}
			} finally {
				this.$Progress.finish();
				this._openingLoanRoute = null;
			}
		},
		onLoanModalHidden() {
			if (this.$route.name === "loan.detail") {
				this.$router.replace({ name: "loan.index" });
			}
		},
		// rowClass() {
		// 	return 'custom-row-height'
		// },
		rowClass(item, type) {
			if (item?.loan?.loan_top_ups?.length > 0 || item?.loan?.refinanced_loan_id == 1) {
				return 'custom-row-height table-custom-light-green'
			} else {
				return 'custom-row-height'
			}

		},
		statusBadge(item) {
			if (item === 'APPROVED') {
				return 'badge akkurate-blue-bg'
			} else if (item === 'REJECTED') {
				return 'badge akkurate-danger-bg'
			} else if (item === 'RUNNING') {
				return 'badge akkurate-green-bg'
			} else if (item === 'PENDING') {
				return 'badge akkurate-warning-bg'
			} else if (item === 'REVERSED') {
				return 'badge akkurate-orange'
			} else if (item === 'EXPIRED') {
				return 'badge akkurate-gray-bg'
			} else {
				return 'badge akkurate-warning-bg'
			}
		},
		// gotoMerge(loanNumber) {
		// 	try {
		showSwapModal(loan_number) {
			this.loan_number = loan_number;
			this.$bvModal.show("bv-modal-swap-loan");
		},
		// 		this.$router.push({ name: 'loan.merge', query: { loan_number: loanNumber || this.form.loan_number } });
		// 	} catch (e) {
		// 		// ignore
		// 	}
		// },
		showMergeModal(loan_number) {
			this.loan_number = loan_number;
			this.$bvModal.show("bv-modal-merge-loan");
		},
		async getLoanDropdown() {
			this.$Progress.start();
			this.isLoading = true;
			await ApiService.get("/loans/paginate/dropdown")
				.then((response) => {
					// console.log(response);
					this.branch_option = response?.data.branches
					this.schemes_option = response?.data?.schemes
					this.user = response?.data?.user
					this.coa_subheads = response?.data?.coa_subheads
					this.loan_stages_options = response?.data?.loan_stages
					this.isLoading = false;
					this.$Progress.finish();
				}).catch((error) => {
					// console.log(error);
				})
		},
		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.loadItems()
		},
		selectPerPage(index) {
			this.perPage = index
			this.loadItems();
		},
		filterTable() {
			this.loadItems();
		},
		checkPemission() {
			if (hasPermission('loan_management_interest_only') || hasPermission('loan_management_interest_principal') || hasPermission('loan_management_adjust_term')) {
				return true
			} else {
				return false;
			}

		},
		// load items is what brings back the rows from server
		async loadItems() {
			this.isBusy = true;  // Set isBusy to true when data is being loaded
			this.$Progress.start();
			this.isLoading = true;
			// console.log(this.form.schemes_ids);
			// if (this.perPage === 'All') {
			//     this.perPage = this.totalRecords;
			// }
			await ApiService.post("/loans/paginate",
				{
					"page": this.currentPage,
					"per_page": this.perPage,
					"scheme_ids": this.form.schemes_ids,
					"branch_ids": this.form.branch_ids,
					// "filter": searchFilter,
					"filter": this.form.filter,
					"loan_number": this.form?.loan_number,
					"status": this.form.status,
					"start_date": this.form.start_date,
					"end_date": this.form.end_date,
					"stages": this.form.loan_stages,
					"gender": this.form.gender,
					"term": this.form.term
				})
				.then((response) => {
					// Handle response and update table data
					this.isBusy = false;  // Set isBusy to false when the data is loaded
					this.$Progress.finish();  // Finish the progress bar

					this.totalRecords = response.data.meta.total;
					this.rows = response.data.data;  // Return data to populate the table
					this.summary = response.data?.summary

					// console.log(this.rows)



				}).catch((error) => {
					console.error(error);
					this.isBusy = false;  // Set isBusy to false in case of an error
					this.$Progress.finish();  // Finish the progress bar even if there's an error

					return []; // Return an empty array in case of error to prevent the table from breaking
				})
				.finally((error) => {
					// console.log(error);
				});
		},
		branch_array(event) {
			// console.log(event);
			this.form.branch_ids = [];
			this.form.branch_ids = event;
			//    console.log(this.form.branch_ids);
		},
		schemes_array(event) {
			this.form.schemes_ids = [];
			this.form.schemes_ids = event;
			// console.log(this.form.schemes_ids);
		},
		async getInsistution() {
			await ApiService.get("/settings/institution")
				.then((response) => {
					// console.log(response);
					this.institution = response.data.data;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		approval() {
			this.loadItems();
		},
		reloadLoans() {
			this.loadItems();
			this.$bvModal.hide("loan-modal-" + this.currentLoanId);
		},
		// Triggered when "View" button is clicked on a row
		onViewLoan(row, type) {
			this.currentLoanId = row.id; // Set the current loan ID
			this.currentLoanData = row; // Set the data of the selected loan to be displayed in the modal
			// Ensure this is done immediately
			// Set the active tab based on the 'type' parameter
			if (type === "view") {
				this.term_active_menu = true;
				this.repayment_active_menu = false;
				this.statement_active_menu = false;
				this.entries_active_menu = false;
				this.adjustment_active_menu = false;
				this.topup_active_menu = false;
				this.refinance_active_menu = false;
				this.writeoff_active_menu = false;
				this.status_active_menu = false;
			} else if (type === "repay") {
				this.term_active_menu = false;
				this.repayment_active_menu = true;
				this.statement_active_menu = false;
				this.entries_active_menu = false;
				this.adjustment_active_menu = false;
				this.topup_active_menu = false;
				this.refinance_active_menu = false;
				this.writeoff_active_menu = false;
				this.status_active_menu = false;
			} else if (type === "entries") {
				this.term_active_menu = false;
				this.repayment_active_menu = false;
				this.entries_active_menu = true;
				this.statement_active_menu = false;
				this.adjustment_active_menu = false;
				this.topup_active_menu = false;
				this.refinance_active_menu = false;
				this.writeoff_active_menu = false;
				this.status_active_menu = false;
			} else if (type === "statement") {
				this.term_active_menu = false;
				this.repayment_active_menu = false;
				this.entries_active_menu = false;
				this.statement_active_menu = true;
				this.adjustment_active_menu = false;
				this.topup_active_menu = false;
				this.refinance_active_menu = false;
				this.writeoff_active_menu = false;
				this.status_active_menu = false;
			} else if (type === "adjustment") {
				this.term_active_menu = false;
				this.repayment_active_menu = false;
				this.entries_active_menu = false;
				this.statement_active_menu = false;
				this.adjustment_active_menu = true;
				this.topup_active_menu = false;
				this.refinance_active_menu = false;
				this.writeoff_active_menu = false;
				this.status_active_menu = false;
			} else if (type === "topup") {
				this.term_active_menu = false;
				this.repayment_active_menu = false;
				this.entries_active_menu = false;
				this.statement_active_menu = false;
				this.adjustment_active_menu = false;
				this.topup_active_menu = true;
				this.refinance_active_menu = false;
				this.writeoff_active_menu = false;
				this.status_active_menu = false;
			} else if (type === "status") {
				this.term_active_menu = false;
				this.repayment_active_menu = false;
				this.entries_active_menu = false;
				this.statement_active_menu = false;
				this.adjustment_active_menu = false;
				this.topup_active_menu = false;
				this.refinance_active_menu = false;
				this.writeoff_active_menu = false;
				this.status_active_menu = true;
			} else if (type === "refinance") {
				this.term_active_menu = false;
				this.repayment_active_menu = false;
				this.entries_active_menu = false;
				this.statement_active_menu = false;
				this.adjustment_active_menu = false;
				this.topup_active_menu = false;
				this.refinance_active_menu = true;
				this.writeoff_active_menu = false;
				this.status_active_menu = false;
			} else if (type === "write_off") {
				this.term_active_menu = false;
				this.repayment_active_menu = false;
				this.entries_active_menu = false;
				this.statement_active_menu = false;
				this.adjustment_active_menu = false;
				this.topup_active_menu = false;
				this.refinance_active_menu = false;
				this.writeoff_active_menu = true;
				this.status_active_menu = false;
			}
			this.$nextTick(() => {
				this.$bvModal.show("loan-modal-" + this.currentLoanId);
			});
		},
		showView() {
			// Optional: Additional logic when the modal is shown
			this.user_pemissions = decryptData(
				localStorage.getItem("user_pemissions")
			);
			this.user_role = decryptData(localStorage.getItem("user_role"));
			this.current_user_id = decryptData(
				localStorage.getItem("userId")
			);
		},
		loanApprovedAction() {
			this.loadItems();
		},
		loanAdjustmenetSaved() {
			this.loadItems();
			this.$bvModal.hide("loan-modal-" + this.currentLoanId);
		},
		showLoanEditModal(row) {
			// console.log(row);
			this.loan_edit = row;
			this.$bvModal.show("bv-modal-loan-edit");
		},
		savedEdit() {
			this.loadItems();
			this.$bvModal.hide("bv-modal-loan-edit");
		},
		handleOk(bvModalEvent) {
			this.filterTable();
		},
		deleteLoan(data) {
			swal.fire({
				title: "Delete Loan",
				text:
					"Are you sure you want to delete loan number " +
					data.loan.loan_number +
					" ?",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				allowOutsideClick: true,
				customClass: {
					cancelButton:
						"btn btn-size akkurate-green-gray modal-btn-width text-white me-2", // Custom class for the "NO" button
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "YES" button
				},
			}).then((result) => {
				if (result.value) {
					this.$Progress.start();
					ApiService.delete("/loans/" + data.loan.id)
						.then((response) => {
							this.$Progress.finish();
							this.loadItems();
							// this.$bvToast.toast('Loan Deleted Successfully', {
							//     title: 'Success',
							//     variant: 'success',
							//     solid: true
							// })
							swal.fire({
								// title: response.statusText,
								text: response.data.message,
								icon: "success",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: "okay", // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton:
										"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
								},
							});
							this.loadItems();
						})
						.catch((error) => {
							this.$Progress.fail();

							swal.fire({
								// title: response.statusText,
								text: error.response.data.message,
								icon: "error",
								allowOutsideClick: true,
								allowEscapeKey: true,
								showCancelButton: false, // Show the "Cancel" button
								confirmButtonText: 'okay', // Customize the text for the "OK" button
								buttonsStyling: false, // Disable SweetAlert2 styling for buttons
								customClass: {
									confirmButton: 'btn akkurate-green-btn modal-btn-width text-white me-2', // Custom class for the "OK" button
								}
							});
						})
				}
			});

		},
		exportToExcel() {
			const workbook = XLSX.utils.book_new();

			// Get the table data
			const tableData = this.rows.map((row) => {
				return {
					loan_number: row.loan.loan_number,
					product_name: row.loan.loan_product.name,
					customer: row.customer.first_name + ' ' + row.customer.last_name,
					principal_amount: row.loan.principal_amount,
					principal_balance: row.loan.principal_balance,
					expected_interest: row.loan.expected_interest,
					interest_balance: row.loan.interest_balance,
					loan_balance: row.loan.loan_balance,
					interest_start_date: row.loan.interest_start_date,
					loan_status: row.loan.status,
					old_code: row.customer.external_code,
					new_code: row.customer.code

				};
			});

			// Convert the table data to a worksheet
			const worksheet = XLSX.utils.json_to_sheet(tableData);

			// Add the worksheet to the workbook
			XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

			// Generate the Excel file buffer
			const excelBuffer = XLSX.write(workbook, {
				type: "array",
				bookType: "xlsx",
			});

			// Save the Excel file
			FileSaver.saveAs(
				new Blob([excelBuffer], {
					type: "application/octet-stream",
				}),
				"table_data.xlsx"
			);
		},
		loanMerged() {
			this.loadItems();
		},
		loanSwapped() {
			this.loadItems();
			this.$bvModal.hide('bv-modal-swap-loan');
		}
	},
};
</script>
<style>
.custom-divider-margin>.dropdown-divider {
	margin: 0px !important;
}

.custom-dropdown-item {
	display: block;
	width: 100%;
	clear: both;
	font-weight: 400;
	color: var(--bs-dropdown-link-color);
	text-align: inherit;
	text-decoration: none;
	white-space: nowrap;
	background-color: transparent;
	border: 0;
	border-radius: var(--bs-dropdown-item-border-radius, 0);
	display: flex;
	justify-content: space-between;
	padding: var(--bs-dropdown-item-padding-y);

}

.icon-color {
	color: #606266;
}
</style>